<template>
  <div class="position-box">
    <div class="head">
      <div class="back-box" @click="goBack">
        <img class="icon" src="@/assets/icon_back.png" alt="back" />
      </div>
      <div>{{this.$t("gjrz.wdtjr")}}</div>
    </div>
    <div class="cont-box">
      <div class="tips" v-show="!isSetUid">{{ this.$t("gjrz.tjrid") }}</div>
      <div class="input-box" v-show="!isSetUid"><input class="input" v-model="u_id" :placeholder="$t('gjrz.qsrtjrid')" type="text"></div>
      <div class="btn-sure" v-show="!isSetUid" @click="sure">{{this.$t("usdttb.qd")}}</div>
      <ul class="ul-box" v-show="isSetUid">
        <li class="li">
          <div class="t1">{{this.$t("gjrz.tjrid")}}</div>
          <div class="t1 text-right">{{this.$t("kxt.sj")}}</div>
        </li>
        <li class="li" v-show="bind_uid">
          <div class="t2">{{bind_uid}}</div>
          <div class="t2 text-right">{{bind_time | timeGs}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "recommender",
  data() {
    return {
      uid: '',
      u_id: '',
      isSetUid: true,
      bind_uid: '',
      bind_time: ''
    };
  },
  mounted() {
    this.uid = localStorage.getItem('userID')
    this.getSetuid();
  },
  methods: {
    goBack() {
      this.$router.push('/index');
    },
    sure(){
      let params = {
        u_id: this.u_id
      }
      if(this.u_id == ''){
        this.$toast.center(this.$t("gjrz.qsrtjrid"));
        return false;
      }else if(this.u_id == this.uid){
        this.$toast.center(this.$t("gjrz.tjridts"));
        return false;
      }
      this.$ajax.post('/web/setuid',params).then((res) => {
        if(res.data.code == 0){
          this.$toast.center(this.$t('gjrz.tjcg'));
          this.getSetuid();
        }else{
          this.$toast.center(this.$t('gjrz.idbcz'));
          return false;
          // this.$router.push('/index');
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    getSetuid(){
      let params = {
        u_id: ''
      }
      this.$ajax.post('/web/setuid').then((res) => {
        let resData = res.data.data;
        if(res.data.code == 0){
          this.bind_uid = resData;
          this.bind_time = res.data.time;
          if(resData){
            this.isSetUid = true;
          }else{
            this.isSetUid = false;
          }
        }else if(res.data.code == 1000){
          setTimeout(()=>{
            this.$router.push('/index');
          },1000)
        }else{
          this.bind_uid = '';
          this.isSetUid = false;
          // this.$router.push('/index');
        }
      }).catch(function(err){
          console.log(err)
      })
    },
  },
};
</script>
<style scoped>
.position-box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  color: #cecece;
  font-size: 0.32rem;
  background: url("../assets/element-background.png") no-repeat center center;
  background-size: cover;
  overflow: hidden;
}
.head {
  position: fixed;
  top: 0;
  width: 100%;
  height: 1.2rem;
  font-size: 0.52rem;
  line-height: 1.2rem;
  /* background: #0e1530; */
  text-align: center;
}
.head .icon {
  position: absolute;
  left: 0.3rem;
  top: 0.3rem;
  width: 0.32rem;
  height: 0.6rem;
}

.cont-box {
  position: absolute;
  left: .48rem;
  right: .48rem;
  top: 1.2rem;
  bottom: 0;
  height: calc(100% - 1.2rem);
}
.cont-box .tips{
  margin-top: .5rem;
  color: #fff;
  font-size: .45rem;
}
.cont-box .input-box{
  height: 1.7rem;
  margin: .5rem 0 1.2rem;
	background-color: #0b101e;
	border-radius: 0.15rem;
}
.cont-box .input-box .input::placeholder{
  color: #d2d2d2;
  font-size: .42rem;
}
.cont-box .input-box .input{
  width: 100%;
  padding: 0 .2rem;
  color: #fff;
  font-size: .48rem;
  line-height: 1.5rem;
}
.cont-box .btn-sure{
  height: 1.28rem;
  color: #fff;
  font-size: .56rem;
  line-height: 1.28rem;
	background-color: #0060ff;
	border-radius: 0.2rem;
  text-align: center;
}
.ul-box{
  margin: .9rem 0;
}
.ul-box .li{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ul-box .li .t1{
  color: #d2d2d2;
  font-size: .45rem;
}
.ul-box .li .t2{
  padding-top: 1rem;
  color: #fff;
  font-size: .45rem;
}
.ul-box .li.text-right{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/recommender.vue